// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2X6I5","rootCenter":"LoadMoreObserver_rootCenter__YeTob","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__11yea"};